// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import VeeValidate from 'vee-validate'
import VueAnalytics from 'vue-analytics'
import axios from 'axios'

import { routes } from './routes'
import { store } from './store/store'

Vue.config.productionTip = false

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    if (
      response.headers['x-token'] &&
      response.config.url.indexOf('api/v1') > 0
    ) {
      localStorage.setItem('sts_token', response.headers['x-token'])
    }
    return response
  },
  (error) => {
    if (
      error.response.status === 401 ||
      error.response.data.error === 'token_expired'
    ) {
      localStorage.removeItem('sts_token')
      router.go('/')
    }
    return Promise.reject(error)
  },
)

VeeValidate.Validator.extend('american_odds', {
  getMessage: (field) =>
    `${field} must be a valid American odds format (e.g., +150 or -200)`,
  validate: (value) => /^[-+]?([1-9]\d{0,2}|1000)$/.test(value)
})

// middleware
Vue.use(VueRouter)
Vue.use(VeeValidate)
Vue.use(Meta, {
  keyName: 'metaInfo'
})
Vue.use(VueAnalytics, {
  id: 'UA-36581750-1',
  router
})
Raven.config('https://d2462cd8e8b2484ebe278fddc1c4b5b7@sentry.io/185848', {
  release: '1.0.0',
  ignoreErrors: [
    /Validation Failed/,
    /Detected close during init/,
    'adsbygoogle',
    'xcomponent',
    'No response from window',
    // Covers both "Window closed for postrobot_method before ack" and
    // "Can not send postrobot_method. Target window is closed" — both mean the
    // PayPal popup/iframe went away mid-handshake, which is user behavior.
    /postrobot_method/,
    'show_ads',
    'pagead',
    // Fired by AdSense's own ResizeObserver on ad-heavy pages (notably /picks).
    // We use ResizeObserver nowhere ourselves, so this is always third-party.
    // Chrome has shipped two different strings for it.
    /ResizeObserver loop/,
    'Can not render button in IE intranet mode',
    'No window to focus'
  ],
  ignoreUrls: [/localhost/, /googlesyndication\.com/]
})
  .addPlugin(RavenVue, Vue)
  .install()
// new Vue instance
// attach Vue to the element with app id
// include App component globally
/* eslint-disable no-new */
new Vue(Vue.util.extend({ router, store }, App)).$mount('#app')

// Register service worker for push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js')
  })
}

// Capture Android install prompt for use in PushSetup component
window.deferredInstallPrompt = null
window.addEventListener('beforeinstallprompt', function (e) {
  e.preventDefault()
  window.deferredInstallPrompt = e
})



// WEBPACK FOOTER //
// ./src/main.js